export const convertRialToToman = amount => {
    return parseInt(amount / 10).toLocaleString("fa");
};